module.exports = __webpack_public_path__ + "static/media/make-deposit-icon.fc55bcb7.png";